import { HttpClient } from '@/src/lib/http/types';
import { handleResponseError } from '@/src/lib/http/utils/handle-response-errors';
import { logResponse } from '@/src/lib/http/utils/fetch-response-logger';

export const handleFetchResponse: HttpClient['handleResponse'] = async function handleFetchResponse<T>(
  response: Response,
): Promise<T | never> {
  await logResponse(response);

  if (!response.ok) {
    await handleResponseError(response);
  }
  //
  if (response.status === 204) {
    // @ts-expect-error 204 has no body
    return response.text();
  }

  return response.json();
};
